import React, {useContext} from "react";
import {ApolloProvider} from "react-apollo";
import {ApolloClient} from "apollo-client";
import {InMemoryCache} from "apollo-cache-inmemory";
import {setContext} from "apollo-link-context";
import {HttpLink} from "apollo-link-http";
import {onError} from "apollo-link-error";
import {ApolloLink} from "apollo-link";
import get from "lodash/get";
import {createCustomFetch} from "@unibuddy/machop/Core/defaultLink";
import AuthProvider from "./Auth/components/AuthProvider/AuthProvider";

const httpLink = new HttpLink({
    uri: `${API_URL}/graphql`,
    credentials: "same-origin",
    fetch: createCustomFetch(),
});
const cache = new InMemoryCache();

const errorMiddleware = onError(({graphQLErrors, networkError}) => {
    if (graphQLErrors)
        graphQLErrors.map(({message, locations, path}) =>
            console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
            ),
        );
    if (networkError) console.log(`[Network error]: ${networkError}`);
});

const cleanTypeName = new ApolloLink((operation, forward) => {
    if (operation.variables) {
        const omitTypename = (key, value) => (key === "__typename" ? undefined : value);
        operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename);
    }
    return forward(operation).map(data => {
        return data;
    });
});

export default function ApiProvider(props) {
    const {authState} = useContext(AuthProvider.Context);
    const token = get(authState, "accessToken", false);
    const middlewareLink = setContext(() => {
        return {
            headers: {
                authorization: token ? `JWT ${token}` : null,
            },
        };
    });
    // We have to "bootstrap" apollo provider client inside a react component because
    // the middlewareLink function needs access to the authState
    // (in order to add the auth token to every request)

    const client = new ApolloClient({
        link: ApolloLink.from([cleanTypeName, errorMiddleware, middlewareLink, httpLink]),
        cache,
    });
    return <ApolloProvider client={client}>{props.children}</ApolloProvider>;
}
